<template>
	<div>
		<preloader v-if="loadingData"></preloader>
		<div class="list-group">
			<a 
				v-for="(data, index) in environments"
				href="#" 
				class="list-group-item list-group-item-action"
				v-on:click.prevent="showEnvironment(index, data)">
                <div class="row">
                	<div class="col-sm-5">
                		<b>
                			{{index}}
                		</b>
                	</div>
                	<div class="col-sm-7">
                		{{data}}
                	</div>
                </div>
			</a>
		</div>

		<div class="modal fade" id="editEnv" role="dialog" aria-labelledby="eventModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header-image">
                    <h3>{{form.key}}</h3>
                </div>
                <preloader v-if="loading"></preloader>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="descripcion">Valor:</label>
                        <input type="text" class="form-control" v-model="form.value">
                        <div v-if="errors && errors.value" class="text-danger">
                            {{ errors.value[0] }}
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <a href="#!" v-on:click.prevent="cancel">
                        Cancelar
                    </a>

                    <button v-on:click.prevent="update" :disabled="loading">
                        Actualizar
                    </button>
                </div>
            </div>
        </div>
    </div>
	</div>
</template>
<script>
	export default {
		mounted(){
			this.getEnvironments();
		},

		data(){
			return {
				loadingData: false,
				loading: false,
				errors: [],
				environments: [],
				form: {
					key: '',
					value: '',
				}
			}
		},

		methods: {
			getEnvironments: function(){
				var url = "/api/environment";
				this.loadingData = true;
				axios.get(url).then(response => {
		        	this.environments = response.data;
	        	}).catch(error=>{
	        		this.$toasted.show('Error al cargar, por favor refresque');
	        		console.log(error.response);
	        	}).then(() => {
	        		this.loadingData = false;
	        	});
			},

			showEnvironment: function(index, data){
				this.form.key = index;
				this.form.value = data;
				$('#editEnv').modal('show');
			},

			cancel: function(){
				this.form.key = '';
				this.form.value = '';
				$('#editEnv').modal('hide');
			},

			update: function(){
				var url = "/api/environment/"+this.form.key;
				this.loading = true;
				axios.put(url, {
					'value': this.form.value
				}).then(response => {
					this.$toasted.show(this.form.key+' actualizado.');
		        	this.cancel();
		        	this.getEnvironments();
	        	}).catch(error=>{
	        		this.$toasted.show('Error al actualizar, por favor intenta de nuevo.');
	        		console.log(error.response);
	        	}).then(() => {
	        		this.loading = false;
	        	});
			},
		}
	}
</script>